var XmxCategory = (function()
{
    /**
     * Props
     */
    var _isDrawerOpened = false;
    var _isDrawerAnimating = false;
    var _configuration = null;
    var _products = [];
    var _ajaxHandle = null;
    var _canPreloadNextPage = false;
    var _preloadScrollPosition = 0;
    var _isLoadingNextPage = false;
    var _preloadedServerResponse = null;
    var _hasLoadedNextPage = false;
    var _displayNextPageImmediately = false;
    var _countdowns = [];
    var _expandedFilterOptions = [];
    var _expandedFilters = [];
    var _didUpdateFilters = false;
    var _intersectionObserver = null;

    /**
     * Elements
     */
    var $_document;
    var $_html;
    var $_grid;
    var $_description;
    var $_listEnd;
    var $_title;
    var $_productCount;
    var $_filterDrawer;
    var $_filterDrawerSkrim;
    var $_filterResetButton;
    var $_filterSubmitButton;
    var $_filterSubmitButtonLabel;
    var $_filters;
    var $_filterForm;
    var $_showMoreMessage;
    var $_showMoreMessageDescription;
    var $_showMoreMessageProgress;
    var $_showMoreMessageButton;
    var $_navigation;
    var $_fillupMessage; 
    var $_fillupMessageButton; 
    var $_filterBar;
    var $_filterBarButton;

    /**
     * Executed after page load
     */
    function boot()
    {
        _configuration = window.naeCategoryConfiguration;
        _products = window.naeProductListConfiguration;

        // Some categories dont have that, e.g. gender landing pages
        if (_configuration == null || _products == null)
        {
            return;
        }

        // Start intersection observer, if browser supports it
        if (XmxApp.supportsIntersectionObserver())
        {
            _intersectionObserver = new IntersectionObserver(onIntersection, {
                root: null,
                rootMargin: '0px',
                threshold: 0.75 // min. 75% on screen
            });
        }

        $_document = jQuery(document);
        $_html = jQuery('html');
        $_grid = jQuery('#category-grid');
        $_listEnd = jQuery('#category-list-end');
        $_title = jQuery('#category-title');
        $_productCount = jQuery('#category-product-count');
        $_description = jQuery('#category-description');
        $_filters = jQuery('#category-filters');

        $_filterDrawer = jQuery('#category-filter-drawer');
        $_navigation = jQuery('#category-navigation');

        // Hook existing product links, so we can save state
        var $productLinks = jQuery('.xmx-category-product-click-target', $_grid);
        $productLinks.on('click', onProductLinkClick); // Mouse 1 
        $productLinks.on('auxclick', onProductLinkClick); // Mouse 3

        if (_intersectionObserver)
        {
            $productLinks.each(function()
            {
                _intersectionObserver.observe(this);
            });
        }

        $_filterForm = jQuery('#category-filter-form');
        $_filterForm.on('submit', onFilterFormSubmit);
        
        $_filterResetButton = jQuery('#category-filter-reset-button');
        $_filterResetButton.on('click', onFilterResetButtonClick);

        $_filterSubmitButton = jQuery('#category-filter-submit-button');
        $_filterSubmitButton.on('click', onFilterSubmitButtonClick);

        $_filterSubmitButtonLabel = jQuery('#category-filter-submit-button-label');

        $_filterDrawerSkrim = jQuery('#category-filter-drawer-skrim');
        $_filterDrawerSkrim.on('click', onFilterDrawerSkrimClick);

        $_filterBar = jQuery('#category-filter-bar');
        $_filterBarButton = jQuery('#category-filter-bar-button');
        $_filterBarButton.on('click', onFilterBarButtonClick);

        $_showMoreMessage = jQuery('#category-show-more-message');
        $_showMoreMessageDescription = jQuery('#category-show-more-message-description');
        $_showMoreMessageProgress = jQuery('#category-show-more-message-progress');
        $_showMoreMessageButton = jQuery('#category-show-more-message-button');
        $_showMoreMessageButton.on('click', onShowMoreMessageButtonClick);

        $_fillupMessage = jQuery('#category-fillup-message');
        $_fillupMessageButton = jQuery('#category-fillup-message-button');
        $_fillupMessageButton.on('click', onFillupMessageButtonClick);

        // Hook all existing grid banners
        /*for (var i in _configuration.banners)
        {
            var banner = _configuration.banners[i];
            var $gridBanner = jQuery('[data-grid-banner-id="' + banner.id + '"]', $_grid);
            
            // Track Banner CTR
            XmxApp.registerInternalPromotion($gridBanner, 'grid_banner_' + banner.id,
            {
                'creative_name': 'grid_banner',
                'creative_slot': _configuration.name,
                'location_id': _configuration.id,
                'promotion_id': 'grid_banner_' + banner.id,
                'promotion_name': banner.name
            });
        }*/

        // if there is a state, try to restore it
        var restoredState = restoreState();

        // Update filters etc.
        updateShowMoreMessage();
        updateProductCount();
        updateNavigation();
        updateFilterBar();

        // Find out when to preload the next page
        updateNextPagePreloading();

        // Hook the scroll event observer.
        // Cannot use intersection observers yet, as they are not that supported right ow.
        XmxApp.registerScrollEventObserver('category', handleScroll);

        // Save the state, so that when we switch categories back and forth, the browser
        // does not jump
        if (!restoredState)
        {
            saveState();
        }

        // Send a category view
        /*global XmxEventQueue*/
        XmxEventQueue.trackEvent('cv', 
        {
            'c': _configuration.id
        });

        // Start all countdowns that have not yet been started via restoreState()
        // Boot all countdowns
        jQuery('[data-start-countdown="true"]', $_grid).each(function()
        {
            /*global XmxCountdown*/
            var countdown = new XmxCountdown(jQuery(this));
            _countdowns.push(countdown);
        });
    }

    /**
        * Fired when a product was visible for at least 1 second
        * 
        * @param {Element} element 
        */
    function onProductImpression(element)
    {
        var productId = parseInt(element.dataset.productId);
        var position = parseInt(element.dataset.position);

        /*global XmxEventQueue*/
        XmxEventQueue.trackEvent('cpv', 
        {
            p: productId, 
            c: _configuration.id,
            r: position
        });

        if (_intersectionObserver)
        {
            _intersectionObserver.unobserve(element);
        }
    }

    /**
    * Handles element<>viewport intersections
    * 
    * @param {IntersectionObserverEntry[]} entries 
    */
    function onIntersection(entries)
    {
        for (var index in entries)
        {
            var entry = entries[index];
            var element = entry.target;
            var timeoutHandle = ('th' in element.dataset) ? element.dataset.th : null;
    
            // If the element is visible for at least 75%, start 
            // a timeout for 1s to count the impression. Otherwise
            // abort the timeout if the element is not visible (anymore)
            if (entry.intersectionRatio >= 0.75)
            {
                if (!timeoutHandle)
                {
                    timeoutHandle = setTimeout(onProductImpression.bind(this, element), 1000);
                    element.dataset.th = timeoutHandle;
                }
            }
            else 
            {
                if (timeoutHandle)
                {
                    clearTimeout(timeoutHandle);
                    delete element.dataset.th;
                }
            }
        }
    }

    function onFilterBarButtonClick()
    {
        openFilterDrawer();
    }

    /**
     * Updates the new filter bar showing promoted filters, custom filters, price filters and sorting in one UI element
     */
    function updateFilterBar()
    {
        // Throw away everything
        jQuery('.xmx-filter-bar-item', $_filterBar).remove();

        // Remember the promoted options, so that they dont draw
        // again when selected
        var renderedOptionIds = [];

        // Add promoted filter options
        if (_configuration.filters.promotedOptions)
        {
            for (var i in _configuration.filters.promotedOptions)
            {
                var promotedOption = _configuration.filters.promotedOptions[i];

                var $filterBarItem = jQuery('<div>');
                $filterBarItem.addClass('xmx-filter-bar-item');
                $filterBarItem.attr('data-type', 'promoted');
                $filterBarItem.attr('data-filter-index', promotedOption.filterIndex);
                $filterBarItem.attr('data-option-index', promotedOption.optionIndex);
                $filterBarItem.on('click', onPromotedFilterBarItemClick);

                if (promotedOption.selected)
                {
                    $filterBarItem.addClass('xmx-filter-bar-item--active');
                }

                if (promotedOption.count == 0)
                {
                    $filterBarItem.addClass('xmx-filter-bar-item--disabled');
                }

                var $filterBarItemIcon = jQuery('<div>');
                $filterBarItemIcon.addClass('xmx-filter-bar-item-icon');
                $filterBarItemIcon.appendTo($filterBarItem);

                var $filterBarItemName = jQuery('<div>');
                $filterBarItemName.addClass('xmx-filter-bar-item-name');
                $filterBarItemName.html(promotedOption.name);
                $filterBarItemName.appendTo($filterBarItem);

                $filterBarItem.insertBefore($_filterBarButton);

                renderedOptionIds.push(promotedOption.id);
            }
        }

        // Then add custom-added filters
        if (_configuration.filters.filters)
        {
            for (var filterIndex in _configuration.filters.filters)
            {
                var filter = _configuration.filters.filters[filterIndex];

                switch (filter.type)
                {
                    case 'price':
                    {
                        if (filter.from || filter.to)
                        {
                            var $priceFilterBarItem = jQuery('<div>');
                            $priceFilterBarItem.addClass('xmx-filter-bar-item');
                            $priceFilterBarItem.attr('data-type', 'custom');
                            $priceFilterBarItem.attr('data-filter-index', filterIndex);
                            $priceFilterBarItem.on('click', onCustomFilterBarItemClick);
                            $priceFilterBarItem.addClass('xmx-filter-bar-item--active');
            
                            var $priceFilterBarItemIcon = jQuery('<div>');
                            $priceFilterBarItemIcon.addClass('xmx-filter-bar-item-icon');
                            $priceFilterBarItemIcon.appendTo($priceFilterBarItem);
            
                            var $priceFilterBarItemName = jQuery('<div>');
                            $priceFilterBarItemName.addClass('xmx-filter-bar-item-name');

                            if (filter.from && filter.to)
                            {
                                $priceFilterBarItemName.html(window.XmxApp.formatAmount(filter.from) + ' - ' + window.XmxApp.formatAmount(filter.to));
                            }
                            else if (filter.to)
                            {
                                $priceFilterBarItemName.html(window.naeCategoryTranslations.to + ' ' + window.XmxApp.formatAmount(filter.to)); 
                            }
                            else if (filter.from)
                            {
                                $priceFilterBarItemName.html(window.naeCategoryTranslations.from + ' ' + window.XmxApp.formatAmount(filter.from)); 
                            }

                            $priceFilterBarItemName.appendTo($priceFilterBarItem);
            
                            $priceFilterBarItem.insertBefore($_filterBarButton);
                        }

                        break;
                    }

                    case 'rating':
                    case 'multiselect': 
                    case 'swatches': 
                    case 'sizes':
                    case 'thumbnails':
                    case 'radio':
                    {
                        for (var optionIndex in filter.options)
                        {
                            var option = filter.options[optionIndex];

                            if (option.selected)
                            {
                                // Skip, if already rendered
                                // Array.includes() is not supported on stoneage browsers (yes, there are users)
                                //if (!renderedOptionIds.includes(option.id))
                                if (renderedOptionIds.indexOf(option.id) == -1)
                                {
                                    var $customFilterBarItem = jQuery('<div>');
                                    $customFilterBarItem.addClass('xmx-filter-bar-item');
                                    $customFilterBarItem.addClass('xmx-filter-bar-item--active');
                                    $customFilterBarItem.attr('data-type', 'custom');
                                    $customFilterBarItem.attr('data-filter-index', filterIndex);
                                    $customFilterBarItem.attr('data-option-index', optionIndex);
                                    $customFilterBarItem.on('click', onCustomFilterBarItemClick);
                    
                                    var $customFilterBarItemIcon = jQuery('<div>');
                                    $customFilterBarItemIcon.addClass('xmx-filter-bar-item-icon');
                                    $customFilterBarItemIcon.appendTo($customFilterBarItem);
                    
                                    var $customFilterBarItemName = jQuery('<div>');
                                    $customFilterBarItemName.addClass('xmx-filter-bar-item-name');
                                    $customFilterBarItemName.html(option.name);
                                    $customFilterBarItemName.appendTo($customFilterBarItem);
                    
                                    $customFilterBarItem.insertBefore($_filterBarButton);
                                }
                            }
                        }
                        break;
                    }
                }
            }
        }

        // Add a chip for the sorting as well
        if (!(_configuration.sorting.order == _configuration.sorting.defaultOrder && _configuration.sorting.direction == 'asc'))
        {
            var sortingName = '';
            
            for (var methodIndex in _configuration.sorting.methods)
            {
                var method = _configuration.sorting.methods[methodIndex];

                if (method.order == _configuration.sorting.order && method.direction == _configuration.sorting.direction)
                {
                    sortingName = method.name;
                    break;
                }
            }

            var $sortingFilterBarItem = jQuery('<div>');
            $sortingFilterBarItem.addClass('xmx-filter-bar-item');
            $sortingFilterBarItem.addClass('xmx-filter-bar-item--active');
            $sortingFilterBarItem.attr('data-type', 'sorting');
            $sortingFilterBarItem.on('click', onSortingFilterBarItemClick);

            var $sortingFilterBarItemIcon = jQuery('<div>');
            $sortingFilterBarItemIcon.addClass('xmx-filter-bar-item-icon');
            $sortingFilterBarItemIcon.appendTo($sortingFilterBarItem);

            var $sortingFilterBarItemName = jQuery('<div>');
            $sortingFilterBarItemName.addClass('xmx-filter-bar-item-name');
            $sortingFilterBarItemName.html(sortingName);
            $sortingFilterBarItemName.appendTo($sortingFilterBarItem);

            $sortingFilterBarItem.insertBefore($_filterBarButton);
        }
    }

    /**
     * User wants to toggle a promoted filter
     */
    function onPromotedFilterBarItemClick()
    {
        var $me = jQuery(this);
        var filterIndex = $me.attr('data-filter-index');
        var optionIndex = $me.attr('data-option-index');

        // If this is disabled, get out of here
        if ($me.hasClass('xmx-filter-bar-item--disabled'))
        {
            return;
        }
        
        // Is it active right now?
        if (_configuration.filters.filters[filterIndex].options[optionIndex].selected)
        {
            // Remove the filter
            _configuration.filters.filters[filterIndex].options[optionIndex].selected = false;

            // Deselect the bar item
            $me.removeClass('xmx-filter-bar-item--active');
        }
        else 
        {
            // Add the filter
            _configuration.filters.filters[filterIndex].options[optionIndex].selected = true;

            // Select the bar item
            $me.addClass('xmx-filter-bar-item--active');
        }

        // Reload everything
        commitFilters(null);
    }

    /**
     * User wants to reset sorting
     */
    function onSortingFilterBarItemClick()
    {
        // Delete filter bar item
        var $me = jQuery(this);
        $me.remove();

        // Reset sorting
        resetSorting();

        // Reload everything
        commitFilters(null);
    }

    /**
     * User wants to remove custom filter
     */
    function onCustomFilterBarItemClick()
    {
        var $me = jQuery(this);
        var filterIndex = $me.attr('data-filter-index');
        var filter = _configuration.filters.filters[filterIndex];

        // Unset price filters
        if (filter.type == 'price')
        {
            _configuration.filters.filters[filterIndex].from = null;
            _configuration.filters.filters[filterIndex].to = null;
        }
        else 
        {
            // Unset option filters
            var optionIndex = $me.attr('data-option-index');

            // Unselect option
            _configuration.filters.filters[filterIndex].options[optionIndex].selected = false;
        }

        // Delete filter bar item
        $me.remove();

        // Reload everything
        commitFilters(null);
    }

    /**
     * Destroys all countdowns so that they clear their interval
     */
    function destroyCountdowns()
    {
        for (var index in _countdowns)
        {
            _countdowns[index].destroy();
        }

        _countdowns = [];
    }

    /**
     * Updates the navigation, including "view all", links and pages
     */
    function updateNavigation()
    {
        // If there is nothing to do, get out of here
        if (_configuration.navigation.length == 0)
        {
            return;
        }

        // Throw away all entries
        $_navigation.empty();

        for (var navigationIndex in _configuration.navigation)
        {
            var entry = _configuration.navigation[navigationIndex];

            var $wrap = jQuery('<div>');
            $wrap.addClass('xmx-category-cross-link-wrap');

            var $link = jQuery('<a>');
            $link.attr('href', entry.url);
            $link.html(entry.name);
            $link.addClass('xmx-cross-link');
            $link.data('index', navigationIndex);

            if (entry.type != 'link')
            {
                $link.on('click', onNavigationLinkClick);
            }

            if (entry.active)
            {
                $link.addClass('xmx-cross-link--current');
            }

            $link.appendTo($wrap);
            $wrap.appendTo($_navigation);
        }
    }

    /**
     * 
     */
    function onNavigationLinkClick()
    {
        var $link = jQuery(this);
        var navigationIndex = $link.data('index');
        var navigationEntry = _configuration.navigation[navigationIndex];
       
        // User has clicked the "view all" button
        if (navigationEntry.type == 'all')
        {
            resetEverythingAndReload();
        }
        else 
        {
            // User has clicked a page
            var postData = {};

            // Jump to page 1
            postData['p'] = 1;

            // Apply filters
            for (var pageFilterIndex in navigationEntry.filters)
            {
                var pageFilter = navigationEntry.filters[pageFilterIndex];

                if (postData[pageFilter.key] === undefined)
                {
                    postData[pageFilter.key] = pageFilter.value;
                }
                else 
                {
                    postData[pageFilter.key] = postData[pageFilter.key] + ',' + pageFilter.value;
                }           
            }

            // Apply sorting
            if (navigationEntry.sortOrder != '' && navigationEntry.sortDirection != '')
            {
                postData['dir'] = navigationEntry.sortDirection;
                postData['order'] = navigationEntry.sortOrder;
            }
            else 
            {
                postData['dir'] = 'asc';
                postData['order'] = 'position';
            }

            // So that we get a JSON response
            postData['is_ajax'] = 1;

            // Reload category
            commitFilters(postData);
        }
        // Do not follow link
        return false;
    }

    /**
     *
     */
    function updateCategoryHeadline()
    {
        $_title.html(_configuration.headline);
    }

    /**
     * 
     */
    function updateBrowserState()
    {
        var urlBefore = window.location.href;

        if (XmxApp.supportsHistoryApi())
        {
            history.replaceState(null, _configuration.pageTitle, _configuration.url);
        }

        // Most browsers currently ignore the  this parameter, 
        // although they may use it in the future. Passing 
        // the empty string here should be safe against future changes to the method. 
        document.title = _configuration.pageTitle;

        // If the URL changes, send a new page view event to Google Analytics
        if (urlBefore != _configuration.url)
        {
            if (typeof gtag !== 'undefined')
            {
                gtag('event', 'page_view', 
                {
                    'page_title': _configuration.pageTitle, 
                    'page_location': _configuration.url
                });
            }

            if (typeof ga !== 'undefined')
            {
                ga('send', 'pageview', window.location.pathname);
            }
        }
    }

    /**
     *
     */
    function updateCategoryDescription()
    {
		// Update the description
		if (_configuration.description)
		{
			$_description.html(_configuration.description);
			$_description.show();
		}
		else 
		{
			$_description.hide();
			$_description.empty();
		}
    }

    /**
     * 
     */
    function updateResetFiltersButton()
    {
        if (_configuration.filters.activeFilterCount > 0)
        {
            $_filterResetButton.show();
        }
        else 
        {
            $_filterResetButton.hide();
        }
    }

    /**
     * Updates the number of products
     */
    function updateProductCount()
    {
        // Update button label
        switch (_configuration.products)
        {
            case 0: $_productCount.html(window.naeCategoryTranslations.noProducts); break;
            case 1: $_productCount.html(window.naeCategoryTranslations.oneProduct); break;
            default: $_productCount.html(window.naeCategoryTranslations.xProducts.replace('%s', _configuration.products)); break;
        }
    }

    /**
     * 
     */
    function updateSubmitButtonLabel()
    {
        // Update button label
        switch (_configuration.products)
        {
            case 0: $_filterSubmitButtonLabel.html(window.naeCategoryTranslations.noResults); break;  
            case 1: $_filterSubmitButtonLabel.html(window.naeCategoryTranslations.viewOneProduct); break;  
            default: $_filterSubmitButtonLabel.html(window.naeCategoryTranslations.viewXProducts.replace('%s', _configuration.products)); break;
        }
    }

    /**
     * Determines wether a next page can be loaded and if so, finds out the
     * scroll position and which it can be pre-loaded. Use with caution, this
     * may cause reflows/layout.
     */
    function updateNextPagePreloading()
    {
        // We can preload the next page, if there are some
        if (_configuration.page < _configuration.pageCount)
        {
            _canPreloadNextPage = true;

            // Take the position of the "show more" message and add an offset.
            // 2000 is ensured to be alright on both mobiles, tablets and desktops
            _preloadScrollPosition = $_showMoreMessage.offset().top - 2000;
        }
        else 
        {
            _canPreloadNextPage = false;
        }
    }

    /**
     * Fires when the user has scrolled. Called only if there has been changes.
     * Called inside an animation frame.
     * 
     * Optimize for performance, as this affects FPS so hard.
     */
    function handleScroll()
    {
        var scrollPosition = XmxApp.scrollOffsetY;

        // Is there a next page?
        if (_canPreloadNextPage)
        {
            // Did we scroll down far enough?
            if (scrollPosition >= _preloadScrollPosition)
            {
                // Are we not already preloading the next page?
                if (!_isLoadingNextPage)
                {
                    // Lock this
                    _canPreloadNextPage = false;
                    _isLoadingNextPage = true;

                    // Get out of the render thread of the browser
                    setTimeout(loadNextPage, 16);
                }
            }
        }
    }

    /**
     * 
     */
    function updateShowMoreMessage()
    {
        if (_configuration.page >= _configuration.pageCount)
        {
            $_showMoreMessage.hide();
        }
        else 
        {
            var viewedProducts = _configuration.page * _configuration.pageSize;
            var percent = Math.round(viewedProducts * 100 / _configuration.products);

            $_showMoreMessageDescription.html(window.naeCategoryTranslations.youHaveSeen.replace('%1', viewedProducts).replace('%2', _configuration.products));
            $_showMoreMessageProgress.css('width', percent + '%');
            $_showMoreMessage.show();
        }
    }

    /**
     * 
     */
    function updateFilters()
    {
        // Throw away all filters
        $_filters.empty();

        // Create a fragment for the filters
        var $fragment = document.createDocumentFragment();

        // Add sorting first
        renderSorting($fragment);

        // And rebuild them
        if (_configuration.filters.filters)
        {
            for (var filterIndex in _configuration.filters.filters)
            {
                var filter = _configuration.filters.filters[filterIndex];

                var $separator = document.createElement('div');
                $separator.classList.add('xmx-filter-separator');
                $fragment.appendChild($separator);

                switch (filter.type)
                {
                    case 'multiselect': renderAttributeFilter($fragment, filterIndex, filter, 'checkbox'); break; // DONE
                    case 'thumbnails': renderAttributeFilter($fragment, filterIndex, filter, 'checkbox'); break; // DONE
                    case 'price': renderPriceFilter($fragment, filterIndex, filter); break; // DONE
                    case 'swatches': renderSwatchesFilter($fragment, filterIndex, filter); break; // DONE
                    case 'sizes': renderSizesFilter($fragment, filterIndex, filter); break; // DONE
                    case 'radio': renderAttributeFilter($fragment, filterIndex, filter, 'radio'); break; // DONE
                    case 'rating': renderRatingFilter($fragment, filterIndex, filter); break; // DONE
                    default: break;
                }
            }
        }

        $_filters[0].appendChild($fragment);
    }

    /**
     * Fired after a price input was changed
     */
    function onPriceFilterInputChange()
    {
        var $input = jQuery(this);
        var name = $input.attr('name');
        var filterIndex = $input.data('filter-index');
        var inputValue = $input.val();
        var value = -1;

        if (inputValue == '')
        {
            value = null;
        }
        else 
        {
            value = parseFloat(inputValue);

            // Clamp it
            if (value < _configuration.filters.filters[filterIndex].minimum)
            {
                value = _configuration.filters.filters[filterIndex].minimum;
            }

            if (value > _configuration.filters.filters[filterIndex].maximum)
            {
                value = _configuration.filters.filters[filterIndex].maximum;
            }
        }

        if (name == 'price-from')
        {
            _configuration.filters.filters[filterIndex].from = value;
        }
        else 
        {
            _configuration.filters.filters[filterIndex].to = value;
        }

        // Reload everything
        commitFilters(null);
    }

    /**
     * Fired after the user has changed a filter
     */
    function onFilterInputChange()
    {
        var $input = jQuery(this);
        var changedFilterIndex = $input.data('filter-index');
        var changedOptionIndex = $input.data('option-index');
        var isSelected = $input.is(':checked');

        // If this is a rating filter, we can only allow a single selection
        // Yes, it is a checkbox, but users would not be able to release
        // a radio selection...
        if (_configuration.filters.filters[changedFilterIndex].attribute == 'rating')
        {
            if (isSelected)
            {
                // Go through all options that are selected already and release it
                for (var optionIndex in _configuration.filters.filters[changedFilterIndex].options)
                {
                    if (optionIndex != changedOptionIndex)
                    {
                        if (_configuration.filters.filters[changedFilterIndex].options[optionIndex].selected)
                        {
                            // Remove filter option
                            _configuration.filters.filters[changedFilterIndex].options[optionIndex].selected = false;

                            // Adjust UI
                            jQuery('#filter-rating-' + _configuration.filters.filters[changedFilterIndex].options[optionIndex].value, $_filters).attr('checked', false);
                        }
                    }
                }
            }
        }

        // Change the selection
        _configuration.filters.filters[changedFilterIndex].options[changedOptionIndex].selected = isSelected;

        // Reload everything
        commitFilters(null);
    }

    /**
     * Fired after the user has changed sorting
     */
    function onSortingInputChange()
    {
        var $input = jQuery(this);
        var sortingIndex = $input.val();
        var sorting = _configuration.sorting.methods[sortingIndex];

        _configuration.sorting.order = sorting.order;
        _configuration.sorting.direction = sorting.direction;

        // Go for it
        commitFilters(null);
    }

    /**
     * 
     * @param {object} filter 
     */
    function renderSorting()
    {
        var $filter = jQuery('<div>');
        $filter.addClass('xmx-filter');
        $filter.addClass('xmx-filter--sorting');
        $filter.attr('data-group', 'sorting');

        // Is the filter opened?
        if (_expandedFilters.includes('sorting'))
        {
            $filter.addClass('xmx-filter--expanded');
        }

        // Create the head
        var $filterHead = jQuery('<div>');
        $filterHead.addClass('xmx-filter-head');
        $filterHead.on('click', onFilterHeadClick);
        $filterHead.appendTo($filter);

        var $filterName = jQuery('<div>');
        $filterName.addClass('xmx-filter-name');
        $filterName.html(window.naeCategoryTranslations.sortBy);
        $filterName.appendTo($filterHead);

        // Does the filter have changes?
        if (_configuration.sorting.order != _configuration.sorting.defaultOrder)
        {
            for (var sotingIndex in _configuration.sorting.methods)
            {
                var sorting = _configuration.sorting.methods[sotingIndex];

                if (_configuration.sorting.order == sorting.order)
                {
                    if (_configuration.sorting.direction == sorting.direction)
                    {
                        var $filterSubtitle = jQuery('<div>');
                        $filterSubtitle.addClass('xmx-subtitle');
                        $filterSubtitle.html(sorting.name);
                        $filterSubtitle.appendTo($filterHead);
                        break;
                    }
                }
            }
        }

        // Create the content
        var $filterContent = jQuery('<div>');
        $filterContent.addClass('xmx-filter-content');
        $filterContent.appendTo($filter);

        var $options = jQuery('<div>');
        $options.addClass('xmx-filter-options');
        $options.appendTo($filterContent);

        for (var methodIndex in _configuration.sorting.methods)
        {
            var method = _configuration.sorting.methods[methodIndex];
            var id = 'sorting-' + method.order + '-' + method.direction;

            var $option = jQuery('<div>');
            $option.addClass('xmx-filter-option');
            $option.appendTo($options);

            var $input = jQuery('<input>');
            $input.addClass('xmx-filter-option-input');
            $input.attr('id', id);
            $input.attr('type', 'radio');
            $input.attr('name', 'sorting');
            $input.attr('value', methodIndex);
            $input.on('change', onSortingInputChange);

            if (_configuration.sorting.order == method.order)
            {
                if (_configuration.sorting.direction == method.direction)
                {
                    $input.attr('checked', true);
                }
            }

            $input.appendTo($option);

            var $optionLabel = jQuery('<label>');
            $optionLabel.attr('for', id);
            $optionLabel.addClass('xmx-filter-option-label');
            $optionLabel.appendTo($option);

            var $optionText = jQuery('<div>');
            $optionText.addClass('xmx-filter-option-text');
            $optionText.appendTo($optionLabel);

            var $optionName = jQuery('<div>');
            $optionName.addClass('xmx-filter-option-name');
            $optionName.html(method.name);
            $optionName.appendTo($optionText);

            var $optionRadio = jQuery('<div>');
            $optionRadio.addClass('xmx-filter-option-radio');
            $optionRadio.appendTo($optionLabel);

            var $optionRadioBullet = jQuery('<div>');
            $optionRadioBullet.addClass('xmx-filter-option-radio-bullet');
            $optionRadioBullet.appendTo($optionRadio);
        }

        $filter.appendTo($_filters);
    }

    /**
     * @param {DocumentFragment} fragment
     * @param {int} filterIndex
     * @param {object} filter 
     */
    function renderSwatchesFilter(fragment, filterIndex, filter)
    {
        var filterSubtitle = '';

        var $filter = document.createElement('div');
        $filter.classList.add('xmx-filter', 'xmx-filter--' + filter.type);
        $filter.setAttribute('data-group', filter.attribute);

        // Is the filter opened?
        if (_expandedFilters.includes(filter.attribute))
        {
            $filter.classList.add('xmx-filter--expanded');
        }

        // Create the head
        var $filterHead = document.createElement('div');
        $filterHead.classList.add('xmx-filter-head');
        $filterHead.addEventListener('click', onFilterHeadClick);
        $filter.appendChild($filterHead);

        var $filterName = document.createElement('div');
        $filterName.classList.add('xmx-filter-name');
        $filterName.innerText = filter.name;
        $filterHead.appendChild($filterName);

        // Create the content
        var $filterContent = document.createElement('div');
        $filterContent.classList.add('xmx-filter-content');
        $filter.appendChild($filterContent);

        if (filter.description)
        {
            var $filterDescription = document.createElement('div');
            $filterDescription.classList.add('xmx-filter-description');
            $filterDescription.innerText = filter.description;
            $filter.appendChild($filterDescription);
        }

        var $colors = document.createElement('div');
        $colors.classList.add('xmx-filter-colors');
        $filterContent.appendChild($colors);

        for (var optionIndex in filter.options)
        {
            var option = filter.options[optionIndex];
            var id = 'filter-' + filter.attribute + '-' + option.value;
            var isDisabled = option.count == 0;

            var $color = document.createElement('div');
            $color.classList.add('xmx-filter-color');

            if (isDisabled)
            {
                $color.classList.add('xmx-filter-color--disabled');    
            }

            $colors.appendChild($color);

            var $input = document.createElement('input');
            $input.classList.add('xmx-filter-color-input');
            $input.setAttribute('id', id);
            $input.setAttribute('type', 'checkbox');
            $input.setAttribute('name', filter.attribute);
            $input.setAttribute('value', option.value);
            $input.setAttribute('data-filter-index', filterIndex);
            $input.setAttribute('data-option-index', optionIndex);
            $input.addEventListener('change', onFilterInputChange);

            if (option.selected)
            {
                $input.setAttribute('checked', true);

                if (filterSubtitle != '')
                {
                    filterSubtitle += ', ';
                }

                filterSubtitle += option.name;
            }

            if (isDisabled)
            {
                $input.setAttribute('disabled', true);
            }

            $color.appendChild($input);

            var $colorLabel = document.createElement('label');
            $colorLabel.setAttribute('for', id);
            $colorLabel.classList.add('xmx-filter-color-label');
            $colorLabel.style['background-color'] = option.color;

            if (option.color == '#ffffff')
            {
                $colorLabel.classList.add('xmx-filter-color-label--outlined');
            }

            $color.appendChild($colorLabel);

            var $colorCheckIcon = document.createElement('div');
            $colorCheckIcon.classList.add('xmx-filter-color-icon');
            $colorLabel.appendChild($colorCheckIcon);

            var $colorCount = document.createElement('div');
            $colorCount.innerText = '(' + option.count + ')';
            $colorCount.classList.add('xmx-filter-option-count');
            $colorLabel.appendChild($colorCount);

            if (option.light)
            {
                $colorCheckIcon.classList.add('xmx-icon-check-white');
                $colorCount.classList.add('xmx-filter-option-count--light');
            }
            else 
            {
                $colorCheckIcon.classList.add('xmx-icon-check');
            }
        }

        // Does the filter have changes?
        if (filterSubtitle != '')
        {
            var $filterSubtitle = document.createElement('div');
            $filterSubtitle.classList.add('xmx-subtitle');
            $filterSubtitle.innerText = filterSubtitle;
            $filterHead.appendChild($filterSubtitle);
        }

        fragment.appendChild($filter);
    }

    /**
     * @param {DocumentFragment} fragment
     * @param {int} filterIndex
     * @param {object} filter 
     */
    function renderSizesFilter(fragment, filterIndex, filter)
    {
        var filterSubtitle = '';

        var $filter = document.createElement('div');
        $filter.classList.add('xmx-filter', 'xmx-filter--' + filter.type);
        $filter.setAttribute('data-group', filter.attribute);

        // Is the filter opened?
        if (_expandedFilters.includes(filter.attribute))
        {
            $filter.classList.add('xmx-filter--expanded');
        }

        // Create the head
        var $filterHead = document.createElement('div');
        $filterHead.classList.add('xmx-filter-head');
        $filterHead.addEventListener('click', onFilterHeadClick);
        $filter.appendChild($filterHead);

        var $filterName = document.createElement('div');
        $filterName.classList.add('xmx-filter-name');
        $filterName.innerText = filter.name;
        $filterHead.appendChild($filterName);

        // Create the content
        var $filterContent = document.createElement('div');
        $filterContent.classList.add('xmx-filter-content');
        $filter.appendChild($filterContent);

        if (filter.description)
        {
            var $filterDescription = document.createElement('div');
            $filterDescription.classList.add('xmx-filter-description');
            $filterDescription.innerText = filter.description;
            $filterContent.appendChild($filterDescription);
        }

        var $sizes = document.createElement('div');
        $sizes.classList.add('xmx-filter-sizes');
        $filterContent.appendChild($sizes);

        for (var optionIndex in filter.options)
        {
            var option = filter.options[optionIndex];
            var id = 'filter-' + filter.attribute + '-' + option.value;
            var isDisabled = option.count == 0;

            var $size = document.createElement('div');
            $size.classList.add('xmx-filter-size');

            if (isDisabled)
            {
                $size.classList.add('xmx-filter-size--disabled');
            }

            $sizes.appendChild($size);

            var $input = document.createElement('input');
            $input.classList.add('xmx-filter-size-input');
            $input.setAttribute('id', id);
            $input.setAttribute('type', 'checkbox');
            $input.setAttribute('name', filter.attribute);
            $input.setAttribute('value', option.value);
            $input.setAttribute('data-filter-index', filterIndex);
            $input.setAttribute('data-option-index', optionIndex);
            $input.addEventListener('change', onFilterInputChange);

            if (option.selected)
            {
                $input.setAttribute('checked', true);

                if (filterSubtitle != '')
                {
                    filterSubtitle += ', ';
                }

                filterSubtitle += option.name;
            }

            if (isDisabled)
            {
                $input.setAttribute('disabled', true);
            }

            $size.appendChild($input);

            var $sizeLabel = document.createElement('label');
            $sizeLabel.setAttribute('for', id);
            $sizeLabel.classList.add('xmx-filter-size-label');
            $size.appendChild($sizeLabel);

            var $optionName = document.createElement('div');
            $optionName.innerText = option.name;
            $optionName.classList.add('xmx-filter-option-name');
            $sizeLabel.appendChild($optionName);

            var $optionCount = document.createElement('div');
            $optionCount.innerText = '(' + option.count + ')';
            $optionCount.classList.add('xmx-filter-option-count');
            $sizeLabel.appendChild($optionCount);
        }

        // Does the filter have changes?
        if (filterSubtitle != '')
        {
            var $filterSubtitle = document.createElement('div');
            $filterSubtitle.classList.add('xmx-subtitle');
            $filterSubtitle.innerText = filterSubtitle;
            $filterHead.appendChild($filterSubtitle);
        }

        fragment.appendChild($filter);
    }

    /**
     * A user has clicked on a filter head
     */
    function onFilterHeadClick()
    {
        var $filterHead = jQuery(this);
        var $filter = $filterHead.parent();
        var filterGroupCode = $filter.data('group');
        var index = _expandedFilters.indexOf(filterGroupCode);

        if (index == -1)
        {
            $filter.addClass('xmx-filter--expanded');

            _expandedFilters.push(filterGroupCode)
        }
        else 
        {
            $filter.removeClass('xmx-filter--expanded');

            _expandedFilters.splice(index, 1);
        }
    }

    /**
     * @param {DocumentFragment} fragment
     * @param {int} filterIndex
     * @param {object} filter 
     * @param {string} type
     */
    function renderAttributeFilter(fragment, filterIndex, filter, type)
    {
        var filterSubtitle = '';

        // Truncating a single filtering value adds needless friction, 
        // as displaying the truncation link takes up as much space as 
        // displaying the actual value would. The truncation threshold 
        // should instead be offset by an extra item so it only 
        // truncates 2+ values.
        // Displaying 6 to 10 filtering values before truncating the 
        // rest of the list was observed to perform decently
        var collapseOptions = filter.options.length >= 7;
        var collapseAt = 5;

        // If the filter will collapse and there is an active option
        // that will be collapsed, prevent collapsing, so that the 
        // active option is visible
        if (collapseOptions && filter.selected)
        {
            // Start at "collapseAt", so basically skip the first 5,
            // as they will never be collapsed and thus dont need
            // to be evaluated
            for (var i = collapseAt; i < filter.options.length; i++)
            {
                if (i >= collapseAt)
                {
                    if (filter.options[i].selected)
                    {
                        collapseOptions = false;
                        break;
                    }
                }
            }
        }

        // If the filter group was expanded before, keep it open.
        // Otherwise you can expand the filter group, then check 
        // an option and uncheck it again. The filter group
        // would then collapse again, so lets prevent that, as it
        // is bad for usability.
        if (_expandedFilterOptions.includes(filter.attribute))
        {
            collapseOptions = false;
        }

        var $filter = document.createElement('div');
        $filter.classList.add('xmx-filter', 'xmx-filter--' + filter.type);
        $filter.setAttribute('data-group', filter.attribute);

        // Is the filter opened?
        if (_expandedFilters.includes(filter.attribute))
        {
            $filter.classList.add('xmx-filter--expanded');
        }

        // Create the head
        var $filterHead = document.createElement('div');
        $filterHead.classList.add('xmx-filter-head');
        $filterHead.addEventListener('click', onFilterHeadClick);
        $filter.appendChild($filterHead);

        var $filterName = document.createElement('div');
        $filterName.classList.add('xmx-filter-name');
        $filterName.innerText = filter.name;
        $filterHead.appendChild($filterName);

        // Create the content
        var $filterContent = document.createElement('div');
        $filterContent.classList.add('xmx-filter-content');
        $filter.appendChild($filterContent);

        if (filter.description)
        {
            var $filterDescription = document.createElement('div');
            $filterDescription.classList.add('xmx-filter-description');
            $filterDescription.innerText = filter.description;
            $filterContent.appendChild($filterDescription);
        }

        var $options = document.createElement('div');
        $options.classList.add('xmx-filter-options');
        $filterContent.appendChild($options);

        for (var optionIndex in filter.options)
        {
            var option = filter.options[optionIndex];
            var id = 'filter-' + filter.attribute + '-' + option.value;
            var isDisabled = option.count == 0;

            var $option = document.createElement('div');
            $option.classList.add('xmx-filter-option');

            if (collapseOptions)
            {
                if (optionIndex >= collapseAt)
                {
                    $option.style['display'] = 'none';
                }
            }

            if (isDisabled)
            {
                $option.classList.add('xmx-filter-option--disabled');
            }

            $options.appendChild($option);

            var $input = document.createElement('input');
            $input.classList.add('xmx-filter-option-input');
            $input.setAttribute('id', id);
            $input.setAttribute('type', type);
            $input.setAttribute('name', filter.attribute);
            $input.setAttribute('value', option.value);
            $input.setAttribute('data-filter-index', filterIndex);
            $input.setAttribute('data-option-index', optionIndex);
            $input.addEventListener('change', onFilterInputChange);

            if (option.selected)
            {
                $input.setAttribute('checked', true);

                if (filterSubtitle != '')
                {
                    filterSubtitle += ', ';
                }

                filterSubtitle += option.name;
            }

            if (isDisabled)
            {
                $input.setAttribute('disabled', true);
            }

            $option.appendChild($input);

            var $optionLabel = document.createElement('label');
            $optionLabel.setAttribute('for', id);
            $optionLabel.classList.add('xmx-filter-option-label');
            $option.appendChild($optionLabel);

            if (filter.type == 'thumbnails')
            {
                var $imageFrame = document.createElement('div');
                $imageFrame.classList.add('xmx-image-link-frame');
                $optionLabel.appendChild($imageFrame);

                $option.classList.add('xmx-filter-option--with-image');

                if (option.image)
                {
                    var $image = document.createElement('img');
                    $image.classList.add('xmx-image-link-image');
                    $image.setAttribute('importance', 'low');
                    $image.setAttribute('width', '46');
                    $image.setAttribute('height', '46');
                    $image.setAttribute('alt', option.name);
                    $image.setAttribute('src', option.image);
                    $imageFrame.appendChild($image);
                }
            }

            var $optionText = document.createElement('div')
            $optionText.classList.add('xmx-filter-option-text');
            $optionLabel.appendChild($optionText);

            var $optionTitle = document.createElement('div');
            $optionTitle.classList.add('xmx-filter-option-title');
            $optionText.appendChild($optionTitle);

            if (option.featured)
            {
                var $badgeContainer = document.createElement('div');
                $badgeContainer.classList.add('xmx-filter-option-badge-container');
                $optionTitle.appendChild($badgeContainer);

                var $badge = document.createElement('div');
                $badge.classList.add('xmx-badge');
                $badge.innerText = window.naeCategoryTranslations.top;
                $badgeContainer.appendChild($badge);
            }

            var $optionName = document.createElement('span');
            $optionName.classList.add('xmx-filter-option-name');
            $optionName.innerText = option.name;
            $optionTitle.appendChild($optionName);

            var $optionCount = document.createElement('span');
            $optionCount.classList.add('xmx-filter-option-count');
            $optionCount.innerText = '(' + option.count + ')';
            $optionTitle.appendChild($optionCount);

            if (option.description)
            {
                $option.classList.add('xmx-filter-option--with-description');

                var $optionDescription = document.createElement('div');
                $optionDescription.classList.add('xmx-filter-option-description');
                $optionDescription.innerText = option.description;
                $optionText.appendChild($optionDescription);
            }

            if (type == 'checkbox')
            {
                var $optionCheckbox = document.createElement('div');
                $optionCheckbox.classList.add('xmx-filter-option-checkbox');
                $optionLabel.appendChild($optionCheckbox);

                var $optionCheckboxIcon = document.createElement('div');
                $optionCheckboxIcon.classList.add('xmx-filter-option-checkbox-icon', 'xmx-icon-check-white');
                $optionCheckbox.appendChild($optionCheckboxIcon);
            }
            else 
            {
                var $optionRadio = document.createElement('div');
                $optionRadio.classList.add('xmx-filter-option-radio');
                $optionLabel.appendChild($optionRadio);

                var $optionRadioBullet = document.createElement('div');
                $optionRadioBullet.classList.add('xmx-filter-option-radio-bullet');
                $optionRadio.appendChild($optionRadioBullet);
            }
        }

        if (collapseOptions)
        {
            var $expandOptions = document.createElement('div');
            $expandOptions.classList.add('xmx-filter-expand-options');
            $filterContent.appendChild($expandOptions);

            var $expandButton = document.createElement('button');
            $expandButton.setAttribute('type', 'button');
            $expandButton.classList.add('xmx-button', 'xmx-button--secondary', 'xmx-button--fullwidth');
            $expandOptions.appendChild($expandButton);
            $expandButton.addEventListener('click', function()
            {
                jQuery('.xmx-filter-option', jQuery($options)).css('display', 'block');

                $expandButton.remove();

                _expandedFilterOptions.push(filter.attribute);
            });

            var $expandButtonLabel = document.createElement('div');
            $expandButtonLabel.innerText = window.naeCategoryTranslations.showMore;
            $expandButtonLabel.classList.add('xmx-button-label');
            $expandButton.appendChild($expandButtonLabel);
        }

        // Does the filter have changes?
        if (filterSubtitle != '')
        {
            var $filterSubtitle = document.createElement('div');
            $filterSubtitle.classList.add('xmx-subtitle');
            $filterSubtitle.innerText = filterSubtitle;
            $filterHead.appendChild($filterSubtitle);
        }

        fragment.appendChild($filter);
    }

    /**
     * Renders xmx-rating
     * 
     * @param {int} rating 
     * @param {int|null} count 
     * @param {element} $parent
     */
     function renderRating(rating, count, $parent)
     {
        var $rating = document.createElement('div');
        $rating.classList.add('xmx-rating');

        for (var star = 1; star <= 5; star++)
        {
            var $star = document.createElement('div');

            if (rating >= star)
            {
                $star.classList.add('xmx-icon-star');
            }
            else 
            {
                if (rating >= star - 0.5)
                {
                    $star.classList.add('xmx-icon-star-half');
                }
                else 
                {
                    $star.classList.add('xmx-icon-star-empty');
                }
            }

            $rating.appendChild($star);
        }

        if (count !== null)
        {
            var $count = document.createElement('div');
            $count.classList.add('xmx-rating-reviews');
            $count.innerText = '(' + count + ')';
            $rating.appendChild($count);
        }

        $parent.appendChild($rating);
    }

    /**
     * @param {DocumentFragment} $fragment
     * @param {*} filterIndex 
     * @param {*} filter 
     */
    function renderRatingFilter($fragment, filterIndex, filter)
    {
        var filterSubtitle = '';

        var $filter = document.createElement('div');
        $filter.classList.add('xmx-filter', 'xmx-filter--' + filter.type);
        $filter.setAttribute('data-group', filter.attribute);

        // Is the filter opened?
        if (_expandedFilters.includes(filter.attribute))
        {
            $filter.classList.add('xmx-filter--expanded');
        }

        // Create the head
        var $filterHead = document.createElement('div');
        $filterHead.classList.add('xmx-filter-head');
        $filterHead.addEventListener('click', onFilterHeadClick);
        $filter.appendChild($filterHead);

        var $filterName = document.createElement('div');
        $filterName.classList.add('xmx-filter-name');
        $filterName.innerText = filter.name;
        $filterHead.appendChild($filterName);

        // Create the content
        var $filterContent = document.createElement('div');
        $filterContent.classList.add('xmx-filter-content');
        $filter.appendChild($filterContent);

        if (filter.description)
        {
            var $filterDescription = document.createElement('div');
            $filterDescription.classList.add('xmx-filter-description');
            $filterDescription.innerText = filter.description;
            $filter.appendChild($filterDescription);
        }

        var $options = document.createElement('div');
        $options.classList.add('xmx-filter-options');
        $filterContent.appendChild($options);

        for (var optionIndex in filter.options)
        {
            var option = filter.options[optionIndex];
            var id = 'filter-' + filter.attribute + '-' + option.value;
            var isDisabled = option.count == 0;
            
            var $option = document.createElement('div');
            $option.classList.add('xmx-filter-option');

            if (isDisabled)
            {
                $option.classList.add('xmx-filter-option--disabled');
            }

            $options.appendChild($option);

            var $input = document.createElement('input');
            $input.classList.add('xmx-filter-option-input');
            $input.setAttribute('id', id);
            $input.setAttribute('type', 'checkbox');
            $input.setAttribute('name', filter.attribute);
            $input.setAttribute('value', option.value);
            $input.setAttribute('data-filter-index', filterIndex);
            $input.setAttribute('data-option-index', optionIndex);
            $input.addEventListener('change', onFilterInputChange);

            if (option.selected)
            {
                $input.setAttribute('checked', true);
                filterSubtitle = option.name;
            }

            if (isDisabled)
            {
                $input.setAttribute('disabled', true);
            }

            $option.appendChild($input);

            var $optionLabel = document.createElement('label');
            $optionLabel.setAttribute('for', id);
            $optionLabel.classList.add('xmx-filter-option-label');
            $option.appendChild($optionLabel);

            var $optionText = document.createElement('div');
            $optionText.classList.add('xmx-filter-option-text');
            $optionLabel.appendChild($optionText);

            var $optionTitle = document.createElement('div');
            $optionTitle.classList.add('xmx-filter-option-title');
            $optionText.appendChild($optionTitle);

            var $rating = document.createElement('div');
            $rating.classList.add('xmx-rating', 'xmx-rating--big');
            $optionTitle.appendChild($rating);

            var $star;

            for (var star = 1; star <= 5; star++)
            {
                $star = document.createElement('span');
                $star.classList.add('xmx-icon');
                $star.classList.add(option.stars >= star ? 'xmx-icon-star' : 'xmx-icon-star-empty');
                $rating.appendChild($star);
            }

            var $optionName = document.createElement('span');
            $optionName.classList.add('xmx-filter-option-name');
            $optionName.innerText = window.naeCategoryTranslations.andMore;
            $optionTitle.appendChild($optionName);

            var $optionCount = document.createElement('span');
            $optionCount.classList.add('xmx-filter-option-count');
            $optionCount.innerText = '(' + option.count + ')';
            $optionTitle.appendChild($optionCount);

            var $optionCheckbox = document.createElement('div');
            $optionCheckbox.classList.add('xmx-filter-option-checkbox');
            $optionLabel.appendChild($optionCheckbox);

            var $optionCheckboxIcon = document.createElement('div');
            $optionCheckboxIcon.classList.add('xmx-filter-option-checkbox-icon', 'xmx-icon-check-white');
            $optionCheckbox.appendChild($optionCheckboxIcon);
        }

        // Does the filter have changes?
        if (filterSubtitle != '')
        {
            var $filterSubtitle = document.createElement('div');
            $filterSubtitle.classList.add('xmx-subtitle');
            $filterSubtitle.innerText = filterSubtitle;
            $filterHead.appendChild($filterSubtitle);
        }

        $fragment.appendChild($filter);
    }

    /**
     * @param {DocumentFragment} fragment
     * @param {int} filterIndex
     * @param {object} filter 
     */
    function renderPriceFilter(fragment, filterIndex, filter)
    {
        var $filter = document.createElement('div');
        $filter.classList.add('xmx-filter', 'xmx-filter--' + filter.type);
        $filter.setAttribute('data-group', 'price');

        // Is the filter opened?
        if (_expandedFilters.includes(filter.attribute))
        {
            $filter.classList.add('xmx-filter--expanded');
        }

        // Create the head
        var $filterHead = document.createElement('div');
        $filterHead.classList.add('xmx-filter-head');
        $filterHead.addEventListener('click', onFilterHeadClick);
        $filter.appendChild($filterHead);

        var $filterName = document.createElement('div');
        $filterName.classList.add('xmx-filter-name');
        $filterName.innerText = filter.name;
        $filterHead.appendChild($filterName);

        // Does the filter have changes?
        if (filter.selected)
        {
            var filterLabel = '';

            if (filter.from && filter.to)
            {
                filterLabel = window.XmxApp.formatAmount(filter.from) + ' - ' + window.XmxApp.formatAmount(filter.to);
            }
            else if (filter.to)
            {
                filterLabel = window.naeCategoryTranslations.to + ' ' + window.XmxApp.formatAmount(filter.to);
            }
            else if (filter.from)
            {
                filterLabel = window.naeCategoryTranslations.from + ' ' + window.XmxApp.formatAmount(filter.from);
            }

            var $filterSubtitle = document.createElement('div');
            $filterSubtitle.classList.add('xmx-subtitle');
            $filterSubtitle.innerText = filterLabel;
            $filterHead.appendChild($filterSubtitle);
        }

        // Create the content
        var $filterContent = document.createElement('div');
        $filterContent.classList.add('xmx-filter-content');
        $filter.appendChild($filterContent);

        var $priceRange = document.createElement('div');
        $priceRange.classList.add('xmx-filter-price-range');
        $filterContent.appendChild($priceRange);

        var $priceInputFrom = document.createElement('input');
        $priceInputFrom.classList.add('xmx-filter-price-range-input', 'xmx-input', 'xmx-input--number');
        $priceInputFrom.setAttribute('type', 'number');
        $priceInputFrom.setAttribute('name', 'price-from');
        $priceInputFrom.setAttribute('min', filter.minimum);
        $priceInputFrom.setAttribute('max', filter.maximum);
        $priceInputFrom.setAttribute('placeholder', XmxApp.formatAmount(filter.minimum));

        if (filter.from)
        {
            $priceInputFrom.setAttribute('value', filter.from);
        }

        $priceInputFrom.setAttribute('data-filter-index', filterIndex);
        $priceInputFrom.addEventListener('change', onPriceFilterInputChange);
        $priceRange.appendChild($priceInputFrom);

        var $separator = document.createElement('div');
        $separator.classList.add('xmx-filter-price-range-separator');
        $separator.innerText = window.naeCategoryTranslations.to;
        $priceRange.appendChild($separator);

        var $priceInputTo = document.createElement('input');
        $priceInputTo.classList.add('xmx-filter-price-range-input', 'xmx-input', 'xmx-input--number');
        $priceInputTo.setAttribute('type', 'number');
        $priceInputTo.setAttribute('name', 'price-to');
        $priceInputTo.setAttribute('min', filter.minimum);
        $priceInputTo.setAttribute('max', filter.maximum);
        $priceInputTo.setAttribute('placeholder', XmxApp.formatAmount(filter.maximum));
        
        if (filter.to)
        {
            $priceInputTo.setAttribute('value', filter.to);
        }

        $priceInputTo.setAttribute('data-filter-index', filterIndex);
        $priceInputTo.addEventListener('change', onPriceFilterInputChange);
        $priceRange.appendChild($priceInputTo);

        fragment.appendChild($filter);
    }

    /**
     * Takes the preloaded server data and displays it, then forgets about it.
     */
    function displayPreloadedPage()
    {
        // Display the pre-loaded data
        handleServerResponse(_preloadedServerResponse);

        // And forget about it
        _preloadedServerResponse = null;
        _hasLoadedNextPage = false;
    }

    /**
     * Used to pre-load product images before the user has pressed the "show more" button.
     * Fired after a page has been pre-loaded while scrolling (Main Thread)
     * 
     * @param {object} response Server response
     */
    function preloadProductImages(response)
    {
        // Does the browser support media query matching? Too lazy to write my own and 
        // support looks good: https://caniuse.com/#search=matchmedia
        if (XmxApp.supportsMediaQueries())
        {
            if (response.products)
            {
                for (var productIndex in response.products)
                {
                    var product = response.products[productIndex];

                    if (product.images)
                    {
                        for (var imageIndex in product.images)
                        {
                            var image = product.images[imageIndex];

                            if (XmxApp.matchMediaQuery(image.media))
                            {
                                XmxApp.downloadImage(image.src);

                                // Download the first matching image only, as the browser
                                // would in the <picture> element
                                break;
                            }
                        }

                        if (XmxApp.isDesktop())
                        {
                            if (product.hoverImage)
                            {
                                XmxApp.downloadImage(product.hoverImage.src);
                            }
                        }
                    }
                }
            }
        }
    }

    /**
     * Takes the response of the server and makes it effective.
     * This is a separate function, so we can either pass in a 
     * pre-loaded server response or one that is handled immediately.
     * 
     * @param {object} response 
     */
    function handleServerResponse(response)
    {
        var productsToRender = [];

        // Append the products
        // In fill up mode, prevent things from being added twice
        if (_configuration.fillupMode)
        {
            // Only take over a couple of things in fill up mode
            _configuration.page = response.category.page;
            _configuration.pageCount = response.category.pageCount;
            _configuration.pageSize = response.category.pageSize;
            _configuration.products = response.category.products;

            for (var productIndex in response.products)
            {
                var addProduct = true;

                // TODO: The complexity of this is pretty high and will even be worse
                // when loading many pages. If we figure out this might become too slow,
                // store a list of all product IDs and use that for checking
                for (var existingProductIndex in _products)
                {
                    if (_products[existingProductIndex].id == response.products[productIndex].id)
                    {
                        addProduct = false;
                        break;
                    }
                }

                if (addProduct)
                {
                    _products.push(response.products[productIndex]);
                    productsToRender.push(response.products[productIndex]);
                }
            }
        }
        else 
        {
            // Only take over the complete configuration whe not in fillup mode
            _configuration = response.category;
            productsToRender = response.products;

            for (var index in response.products)
            {
                _products.push(response.products[index]);
            }
        }

        // Desktop Chrome is keeping the load more button in focus, so remeber the current scroll position
        // and then jump to where we have been before
        var scrollPosition = XmxApp.scrollOffsetY;

        renderProducts(productsToRender);
        updateFilters();
        updateCategoryHeadline();
        updateCategoryDescription();
        updateBrowserState();
        updateShowMoreMessage();
        updateProductCount();
        updateResetFiltersButton();
        updateFilterBar();
        updateSubmitButtonLabel();
        updateNavigation();

        $_document.scrollTop(scrollPosition);

        // Find out when to pre-load next time (causes reflow)
        updateNextPagePreloading();

        // Save the current state
        saveState();
    }

    /**
     * Saves the current state
     */
    function saveState()
    {
        if (XmxApp.supportsSessionStorage())
        {
            XmxApp.setSessionStorageString('xmx-category-id', _configuration.id);
            XmxApp.setSessionStorageString('xmx-category-scroll-position', XmxApp.scrollOffsetY);
            XmxApp.setSessionStorageJSON('xmx-category-configuration', _configuration);
            XmxApp.setSessionStorageJSON('xmx-category-products', _products);
        }
    }

    /**
     * Restores the last saved state
     * 
     * @return bool True if state was restored
     */
    function restoreState()
    {
        var restoredState = false;

        if (XmxApp.supportsSessionStorage())
        {
            var categoryId = XmxApp.getSessionStorageString('xmx-category-id');

            // Is the saved state for this category id? if so, load it
            if (categoryId == _configuration.id)
            {
                // Only restore it if there is no page ("p") parameter.
                // The p parameter is only used when paginating in the browser via
                // the URL. Mostly for Google only. Users usually never get there, hopefully,
                // since we have a much nicer pagination for users via the load more button.

                // Restore configuration
                var configuration = XmxApp.getSessionStorageJSON('xmx-category-configuration');

                if (configuration)
                {
                    // Only restore the state, if the states matches.
                    // The URL contains the filters, sorting and category, so basically
                    // everything we needed :)
                    if (configuration.url != _configuration.url)
                    {
                        return;
                    }

                    // TODO: Cache Buster for

                    _configuration = configuration;
                }

                // Restore products
                var products = XmxApp.getSessionStorageJSON('xmx-category-products');

                if (products)
                {
                    // Delete all product and banner elements and replace them
                    jQuery('.xmx-category-product', $_grid).remove();
                    jQuery('.xmx-category-grid-banner', $_grid).remove();
                    destroyCountdowns();

                    /*for (var i in _configuration.banners)
                    {
                        XmxApp.unregisterInternalPromotion('grid_banner_', _configuration.banners[i].id);
                    }*/

                    _products = products;

                    renderProducts(_products);
                }

                // Restore scroll position
                var scrollPosition = XmxApp.getSessionStorageString('xmx-category-scroll-position');

                if (scrollPosition)
                {
                    $_document.scrollTop(scrollPosition);
                }
               
                restoredState = true;
            }
        }

        return restoredState;
    }

    /**
     * Add new products to the results
     * 
     * @param {array} products 
     */
    function renderProducts(products)
    {
        var position = 0;
        var countdownsToStart = [];
        var showBanners = _configuration.filters.activeFilterCount == 0 
            && _configuration.sorting.order == _configuration.sorting.defaultOrder
                    && _configuration.sorting.direction == 'asc'
                    && _configuration.page == 1;

        var $fragment = document.createDocumentFragment();

        for (var productIndex in products)
        {
            position++;
            var product = products[productIndex];
            var isFeatured = product['id'] == _configuration['bestsellerProductId'];

            // Render Banners
            if (_configuration.banners && showBanners)
            {
                var positionKey = "p" + position;

                if (_configuration.banners[positionKey] !== undefined)
                {
                    var banner = _configuration.banners[positionKey];

                    var $bannerLink = document.createElement('a');
                    $bannerLink.classList.add('xmx-category-grid-banner');
                    $bannerLink.setAttribute('href', banner.link);

                    if (banner.size == 'big')
                    {
                        $bannerLink.classList.add('xmx-category-grid-banner--big');
                    }

                    if (banner.nofollow)
                    {
                        $bannerLink.setAttribute('rel', 'nofollow');
                    }
                    
                    var $bannerContent = document.createElement('div');
                    $bannerContent.classList.add('xmx-category-grid-banner-content');
                    $bannerLink.appendChild($bannerContent);
                    
                    var $bannerPicture = document.createElement('picture')
                    $bannerPicture.classList.add('xmx-category-grid-banner-picture');
                    $bannerContent.appendChild($bannerPicture);
                    
                    var lastBannerImageData = '';

                    for (imageIndex in banner.images)
                    {
                        var bannerImageData = banner.images[imageIndex];
                        
                        var $bannerSource = document.createElement('source')
                        $bannerSource.setAttribute('media', bannerImageData.media);
                        $bannerSource.setAttribute('srcset', bannerImageData.src);
                        $bannerPicture.appendChild($bannerSource);
                        
                        lastBannerImageData = bannerImageData;
                    }
                    
                    var $bannerImage = document.createElement('img');
                    $bannerImage.classList.add('xmx-category-grid-banner-image');
                    $bannerImage.setAttribute('src', lastBannerImageData.src);
                    $bannerImage.setAttribute('alt', banner.imageAlt);
                    $bannerPicture.appendChild($bannerImage);
                    
                    var $bannerCta = document.createElement('div');
                    $bannerCta.classList.add('xmx-category-grid-banner-overlay');
                    
                    if (banner.color == 'white')
                    {
                        $bannerCta.classList.add('xmx-category-grid-banner-overlay--white');
                    }
                    
                    $bannerContent.appendChild($bannerCta);
                    
                    if (banner.label != '')
                    {
                        var $bannerLabel = document.createElement('div');
                        $bannerLabel.classList.add('xmx-label');
                        $bannerLabel.innerText = banner.label;
                        $bannerCta.appendChild($bannerLabel);
                    }
                    
                    if (banner.title != '')
                    {
                        var $bannerTitle = document.createElement('div');
                        $bannerTitle.classList.add('xmx-h2');
                        $bannerTitle.innerText = banner.title;
                        $bannerCta.appendChild($bannerTitle);
                    }
                    
                    if (banner.description != '')
                    {
                        var $bannerDescription = document.createElement('div');
                        $bannerDescription.classList.add('xmx-short-description');
                        $bannerDescription.innerText = banner.description;
                        $bannerCta.appendChild($bannerDescription);
                    }
                    
                    if (banner.countdown)
                    {
                        var $countdown = document.createElement('div');
                        $countdown.classList.add('xmx-countdown', 'xmx-countdown--big', 'xmx-countdown--' + banner.countdownStyle);
                        $countdown.setAttribute('data-deadline', banner.deadline);
                        $bannerCta.appendChild($countdown);
                        
                        // Days
                        var $countdownDaysBox = document.createElement('div');
                        $countdownDaysBox.classList.add('xmx-countdown-box', 'xmx-countdown--days-only');
                        $countdown.appendChild($countdownDaysBox);
                        
                        var $countdownDaysDigit = document.createElement('div');
                        $countdownDaysDigit.classList.add('xmx-countdown-digit', 'xmx-countdown--days');
                        $countdownDaysBox.appendChild($countdownDaysDigit);
                        
                        var $countdownDaysLabel = document.createElement('div');
                        $countdownDaysLabel.classList.add('xmx-label');
                        $countdownDaysLabel.innerText = window.naeCategoryTranslations.countdownDays;
                        $countdownDaysBox.appendChild($countdownDaysLabel);
                        
                        // Hours
                        var $countdownHoursBox = document.createElement('div');
                        $countdownHoursBox.classList.add('xmx-countdown-box');
                        $countdown.appendChild($countdownHoursBox);
                        
                        var $countdownHoursDigit = document.createElement('div');
                        $countdownHoursDigit.classList.add('xmx-countdown-digit', 'xmx-countdown--hours');
                        $countdownHoursBox.appendChild($countdownHoursDigit);

                        var $countdownHoursLabel = document.createElement('div');
                        $countdownHoursLabel.classList.add('xmx-label');
                        $countdownHoursLabel.innerText = window.naeCategoryTranslations.countdownHours;
                        $countdownHoursBox.appendChild($countdownHoursLabel);
                        
                        // Minutes
                        var $countdownMinutesBox = document.createElement('div');
                        $countdownMinutesBox.classList.add('xmx-countdown-box');
                        $countdown.appendChild($countdownMinutesBox);
                        
                        var $countdownMinutesDigit = document.createElement('div');
                        $countdownMinutesDigit.classList.add('xmx-countdown-digit', 'xmx-countdown--minutes');
                        $countdownMinutesBox.appendChild($countdownMinutesDigit);
                        
                        var $countdownMinutesLabel = document.createElement('div');
                        $countdownMinutesLabel.classList.add('xmx-label');
                        $countdownMinutesLabel.innerText = window.naeCategoryTranslations.countdownMinutes;
                        $countdownMinutesBox.appendChild($countdownMinutesLabel);
                        
                        // Seconds
                        var $countdownSecondsBox = document.createElement('div');
                        $countdownSecondsBox.classList.add('xmx-countdown-box');
                        $countdown.appendChild($countdownSecondsBox);
                        
                        var $countdownSecondsDigit = document.createElement('div');
                        $countdownSecondsDigit.classList.add('xmx-countdown-digit', 'xmx-countdown--seconds');
                        $countdownSecondsBox.appendChild($countdownSecondsDigit);
                        
                        var $countdownSecondsLabel = document.createElement('div');
                        $countdownSecondsLabel.classList.add('xmx-label');
                        $countdownSecondsLabel.innerText = window.naeCategoryTranslations.countdownSeconds;
                        $countdownSecondsBox.appendChild($countdownSecondsLabel);
                        
                        countdownsToStart.push($countdown);
                    }

                    if (banner.button != '')
                    {
                        var $bannerButton = document.createElement('span');
                        $bannerButton.classList.add('xmx-button', 'xmx-button--' + banner.buttonStyle);
                        $bannerCta.appendChild($bannerButton);
                        
                        var $bannerButtonLabel = document.createElement('div');
                        $bannerButtonLabel.classList.add('xmx-button-label', 'xmx-button-label--big-desktop');
                        $bannerButtonLabel.innerText = banner.button;
                        $bannerButton.appendChild($bannerButtonLabel);
                    }
                    
                    $fragment.appendChild($bannerLink);
                    
                    // Track Banner CTR
                    /*XmxApp.registerInternalPromotion(jQuery($bannerLink), 'grid_banner_' + banner.id, 
                    {
                        'creative_name': 'grid_banner',
                        'creative_slot': _configuration.name,
                        'location_id': _configuration.id,
                        'promotion_id': 'grid_banner_' + banner.id,
                        'promotion_name': banner.name
                    });*/
                }
            }
            
            var $productElement = document.createElement('div');
            $productElement.classList.add('xmx-category-product');

            if (isFeatured)
            {
                $productElement.classList.add('xmx-category-product-hero');
            }
            else 
            {
                $productElement.classList.add('xmx-category-product--' + _configuration.displayType);
            }

            var $inner = document.createElement('div');
            $inner.classList.add('xmx-category-product-inner');
            $productElement.appendChild($inner);

            var $link = document.createElement('a');
            $link.classList.add('xmx-category-product-click-target');
            $link.setAttribute('href', product.url);
            $link.setAttribute('data-product-id', product.id);
            $link.setAttribute('data-position', product.position);
            $link.setAttribute('title', product.name);
            $link.addEventListener('click', onProductLinkClick); // Mouse 1 
            $link.addEventListener('auxclick', onProductLinkClick); // Mouse 3
            $inner.appendChild($link);

            // Track impressions
            if (_intersectionObserver)
            {
                _intersectionObserver.observe($link);
            }

            // Images
            var $image = document.createElement('div');
            $image.classList.add('xmx-product-image', 'xmx-product-image--' + product.imageType, 'xmx-product-hover-image--' + product.hoverImageType);
            $inner.appendChild($image);

            var $imageRegular = document.createElement('div');
            $imageRegular.classList.add('xmx-product-image-regular');
            $image.appendChild($imageRegular);

            if (product.images.length > 0)
            {
                var $imageRegularPicture = document.createElement('picture');
                $imageRegular.appendChild($imageRegularPicture);

                var lastImageData = null;

                for (var imageIndex in product.images)
                {
                    var imageData = product.images[imageIndex];
                    var $imageRegularSource = document.createElement('source');
                    $imageRegularSource.setAttribute('media', imageData.media);
                    $imageRegularSource.setAttribute('srcset', imageData.src);
                    $imageRegularPicture.appendChild($imageRegularSource);

                    lastImageData = imageData;
                }

                if (lastImageData)
                {
                    var $imageRegularImage = document.createElement('img');
                    $imageRegularImage.setAttribute('src', lastImageData.src);
                    $imageRegularImage.setAttribute('width', lastImageData.width);
                    $imageRegularImage.setAttribute('height', lastImageData.height);
                    $imageRegularImage.setAttribute('alt', product.name);
                    $imageRegularPicture.appendChild($imageRegularImage);
                }
            }

            // Hover image
            if (product.hoverImage)
            {
                var $hoverImage = document.createElement('div');
                $hoverImage.classList.add('xmx-product-image-hover');
                $image.appendChild($hoverImage);

                var $hoverImagePicture = document.createElement('picture');
                $hoverImage.appendChild($hoverImagePicture);

                var $mobileHoverImage = document.createElement('source');
                $mobileHoverImage.setAttribute('media', '(max-width: 1279px)');
                $mobileHoverImage.setAttribute('srcset', '/static/transparent.gif');
                $hoverImagePicture.appendChild($mobileHoverImage);

                var $desktopHoverImage = document.createElement('source');
                $desktopHoverImage.setAttribute('media', '(min-width: 1280px)');
                $desktopHoverImage.setAttribute('srcset', product.hoverImage.src);
                $hoverImagePicture.appendChild($desktopHoverImage);

                var $hoverImageImage = document.createElement('img');
                $hoverImageImage.setAttribute('importance', 'low');
                $hoverImageImage.setAttribute('width', product.hoverImage.width);
                $hoverImageImage.setAttribute('height', product.hoverImage.height);
                $hoverImageImage.setAttribute('alt', product.name);
                $hoverImageImage.setAttribute('src', product.hoverImage.src);
                $hoverImagePicture.appendChild($hoverImageImage);
            }

            if (product.isOutOfStock)
            {
                var $stockBadges = document.createElement('div');
                $stockBadges.classList.add('xmx-product-image-badges');
                $image.appendChild($stockBadges);

                var $stockBadge = document.createElement('div');
                $stockBadge.classList.add('xmx-badge', 'xmx-badge--stock');
                $stockBadge.innerText = product.stockBadge;
                $stockBadges.appendChild($stockBadge);
            }
            else 
            {
                // Image badges
                if (product.primaryBadge != '' || product.secondaryBadge != '' || product.specialBadge != '' || product.campaignBadge != '')
                {
                    var $badges = document.createElement('div');
                    $badges.classList.add('xmx-product-image-badges');
                    $image.appendChild($badges);

                    if (product.campaignBadge != '')
                    {
                        var $campaignBadge = document.createElement('div');
                        $campaignBadge.classList.add('xmx-badge', 'xmx-badge--special');
                        $campaignBadge.innerText = product.campaignBadge;
                        $badges.appendChild($campaignBadge);
                    }

                    if (product.specialBadge != '')
                    {
                        var $specialBadge = document.createElement('div');
                        $specialBadge.classList.add('xmx-badge', 'xmx-badge--special');
                        $specialBadge.innerText = product.specialBadge;
                        $badges.appendChild($specialBadge);
                    }

                    if (product.primaryBadge != '')
                    {
                        var $primaryBadge = document.createElement('div');
                        $primaryBadge.classList.add('xmx-badge', 'xmx-badge--primary');
                        $primaryBadge.innerText = product.primaryBadge;
                        $badges.appendChild($primaryBadge);
                    }

                    if (product.secondaryBadge != '')
                    {
                        var $secondaryBadge = document.createElement('div');
                        $secondaryBadge.classList.add('xmx-badge', 'xmx-badge--secondary');
                        $secondaryBadge.innerText = product.secondaryBadge;
                        $badges.appendChild($secondaryBadge);
                    }
                }
            }

            // Textual part
            var $text = document.createElement('div');
            $text.classList.add('xmx-category-product-text');

            if (isFeatured)
            {
                $text.classList.add('xmx-icon-x');
            }

            $inner.appendChild($text);

            if (product.rating > 0 && _configuration.displayType == 'spec-driven')
            {
                renderRating(product.rating, product.reviews, $text);
            }

            if (product.brand != '')
            {
                var $brand = document.createElement('div');
                $brand.classList.add('xmx-subtitle');
                $brand.innerText = product.brand;
                $text.appendChild($brand);
            }

            if (product.name != '')
            {
                var $name = document.createElement('a');
                $name.classList.add('xmx-name');
                $name.classList.add('xmx-name--link');
                $name.setAttribute('href', product.url);
                $name.setAttribute('data-product-id', product.id);
                $link.setAttribute('data-position', product.position);
                $name.setAttribute('title', product.name);
                $name.addEventListener('click', onProductLinkClick); // Mouse 1 
                $name.addEventListener('auxclick', onProductLinkClick); // Mouse 3
                $name.innerText = product.name;
                $text.appendChild($name);
            }

            if (product.subtitle != '' && _configuration.displayType == 'spec-driven')
            {
                var $subtitle = document.createElement('div');
                $subtitle.classList.add('xmx-short-description');
                $subtitle.innerText = product.subtitle;
                $text.appendChild($subtitle);
            }

            // Tags
            if (product.freeShipping || product.tags.length > 0)
            {
                var $tags = document.createElement('div');
                $tags.classList.add('xmx-tags');
                $text.appendChild($tags);

                for (var tagIndex in product.tags)
                {
                    var $tag = document.createElement('div');
                    $tag.classList.add('xmx-tag');
                    $tag.innerText = product.tags[tagIndex];
                    $tags.appendChild($tag);
                }

                if (product.freeShipping)
                {
                    var $freeShippingTag = document.createElement('div');
                    $freeShippingTag.classList.add('xmx-tag', 'xmx-tag--shipping');
                    $freeShippingTag.innerText = window.naeCategoryTranslations.freeShipping;
                    $tags.appendChild($freeShippingTag);
                }
            }

            // Price
            var $price = document.createElement('div');
            $price.classList.add('xmx-price');
            $text.appendChild($price);

            if (product.finalPrice < product.price)
            {
                var $oldPrice = document.createElement('div');
                $oldPrice.classList.add('xmx-price-old');
                $oldPrice.innerText = product.priceString;
                $price.appendChild($oldPrice);

                var $newPrice = document.createElement('div');
                $newPrice.classList.add('xmx-price-new');

                if (product.showFromPrice)
                {
                    $newPrice.innerText = window.naeCategoryTranslations.from + ' ' + product.finalPriceString;
                }
                else 
                {
                    $newPrice.innerText = product.finalPriceString;
                }

                $price.appendChild($newPrice);

                var $discount = document.createElement('div');
                $discount.classList.add('xmx-price-discount');
                $discount.innerText = product.discountPercentString;
                $price.appendChild($discount);
            }
            else 
            {
                var $regularPrice = document.createElement('div');
                $regularPrice.classList.add('xmx-price-regular');
                
                if (product.showFromPrice)
                {
                    $regularPrice.innerText = window.naeCategoryTranslations.from + ' ' + product.finalPriceString; 
                }
                else 
                {
                    $regularPrice.innerText = product.finalPriceString;
                }

                $price.appendChild($regularPrice);
            }

            if (product.basePriceString !== null && product.basePriceString != '')
            {
                var $basePrice = document.createElement('div');
                $basePrice.classList.add('xmx-price-unit');
                $basePrice.innerText = product.basePriceString;
                $text.appendChild($basePrice);
            }

            $fragment.appendChild($productElement);
        }

        $_listEnd[0].before($fragment);

        for (var countdownIndex in countdownsToStart)
        {
            /*global XmxCountdown*/
            var countdownHandle = new XmxCountdown(jQuery(countdownsToStart[countdownIndex]));
            _countdowns.push(countdownHandle);
        }
    }

	/**
	 *
	 */
	function buildPostData(page)
	{
		var postData = {};

        if (_configuration.filters.filters)
        {
            for (var i in _configuration.filters.filters)
            {
                var filter = _configuration.filters.filters[i];

                switch (filter.type)
                {
                    case 'price':
                    {
                        if (filter.from && filter.to)
                        {
                            postData['price'] = filter.from + '-' + filter.to;
                        }
                        else if (filter.to)
                        {
                            postData['price'] = '-' + filter.to;
                        }
                        else if (filter.from)
                        {
                            postData['price'] = filter.from + '-';
                        }

                        break;
                    }

                    case 'swatches':
                    case 'multiselect':
                    case 'radio':
                    case 'sizes':
                    case 'thumbnails':
                    case 'rating':
                    {
                        for (var j in filter.options)
                        {
                            var option = filter.options[j];

                            if (option.selected)
                            {
                                if (postData[filter.attribute] === undefined)
                                {
                                    postData[filter.attribute] = option.value;
                                }
                                else 
                                {
                                    postData[filter.attribute] = postData[filter.attribute] + ',' + option.value;
                                }
                            }
                        }

                        break;
                    }
                }
            }
        }

		// Add the current page
		postData['p'] = page;

		// Add the current direction
		postData['dir'] = _configuration.sorting.direction;

		// Add the current sorting
		postData['order'] = _configuration.sorting.order;

		// So that we get a JSON response
		postData['is_ajax'] = 1;

		return postData;
	}

    /**
     * User has clicked the "show more products" button to show products
     * from another category
     */
    function onFillupMessageButtonClick()
    {
        // This should never be the case...
        if (!_configuration.fillupCategory)
        {
            return;
        }

        // Get out of there, if we are in fill-up mode
        if (_configuration.fillupMode)
        {
            return;
        }

        // Remember that we are in fill up mode
        _configuration.fillupMode = true;
        _configuration.page = 0; // loadNextPage() increases this

        // Reset everything
        _isLoadingNextPage = false;
        _hasLoadedNextPage = false;
        _displayNextPageImmediately = true;

        // Set the button into loading state
        $_fillupMessageButton.addClass('xmx-button--loading');

        loadNextPage();
    }

    /**
     *  User has clicked the "show more products" button
     */
    function onShowMoreMessageButtonClick(event)
    {
        // Do not actually follow this link
        event.preventDefault();

        // Did we pre-loading the page already?
        // If so, just show it
        if (_hasLoadedNextPage)
        {
            displayPreloadedPage();
        }
        else 
        {
            // We do not have the next page data yet, so let us
            // load it if not in progress already and ensure it 
            // is displayed immediately
            _displayNextPageImmediately = true;

            // Indicate things are loading
            $_showMoreMessageButton.addClass('xmx-button--loading');

            if (!_isLoadingNextPage)
            {
                _isLoadingNextPage = true;

                loadNextPage();
            }
        }
    }

    /**
     * Creates a certain number of skeletons
     * 
     * @param {int} skeletonCount 
     */
    function createProductSkeletons(skeletonCount)
    {
        var $fragment = document.createDocumentFragment();

        for (var i = 0; i < skeletonCount; i++)
        {
            var $skeleton = document.createElement('div');
            $skeleton.classList.add('xmx-category-product-skeleton');

            if (_configuration.displayType == 'spec-driven')
            {
                $skeleton.classList.add('xmx-category-product-skeleton--spec-driven');
            }

            var $link = document.createElement('div');
            $link.classList.add('xmx-category-product-skeleton-link');
            $skeleton.appendChild($link);

            var $image = document.createElement('div');
            $image.classList.add('xmx-skeleton', 'xmx-category-product-skeleton-image');
            $link.appendChild($image);

            var $text = document.createElement('div');
            $text.classList.add('xmx-category-product-skeleton-text');
            $link.appendChild($text);

            var $line1 = document.createElement('div');
            $line1.classList.add('xmx-skeleton', 'xmx-category-product-skeleton-line-1');
            $text.appendChild($line1);

            var $line2 = document.createElement('div');
            $line2.classList.add('xmx-skeleton', 'xmx-category-product-skeleton-line-2');
            $text.appendChild($line2);

            var $line3 = document.createElement('div');
            $line3.classList.add('xmx-skeleton', 'xmx-category-product-skeleton-line-3');
            $text.appendChild($line3);

            $fragment.appendChild($skeleton);
        }

        $_listEnd[0].before($fragment);
    }

    /**
     * Deletes all product skeletons from the grid
     */
    function removeProductSkeletons()
    {
        jQuery('.xmx-category-product-skeleton', $_grid).remove();
    }

    /**
     * Sends the filters to Magento and re-loads the category
     */
    function commitFilters(enforcedPostData)
    {
        // Abort AJAX stuff going on right now
        if (_ajaxHandle !== null)
        {
            _ajaxHandle.abort();
        }

        // Show button loader
        $_filterSubmitButton.addClass('xmx-button--loading');

        // Count all products, so we can replace them with skeletons
        // Ensure there are at least one skeleton
        var skeletonCount = Math.max(1, _products.length);

        // Forget about all products
        _products = [];

        // Remove all products and grid banners
        jQuery('.xmx-category-product', $_grid).remove();
        jQuery('.xmx-category-grid-banner', $_grid).remove();
        destroyCountdowns();

        // Remove all grid banner internal promotion tracking
        /*for (var i in _configuration.banners)
        {
            XmxApp.unregisterInternalPromotion('grid_banner_', _configuration.banners[i].id);
        }*/

        // Add skeletons
        createProductSkeletons(skeletonCount);

        // Re-load page #1
        var postData = enforcedPostData ? enforcedPostData : buildPostData(1);

        jQuery.ajax
        ({
            url: '/catalog/category/view/id/' + _configuration.id,
            dataType: 'json',
            type: 'post',
            cache: false,
            data: postData,
            xhr: function()
            {
                _ajaxHandle = new window.XMLHttpRequest();

                return _ajaxHandle;
            },
            success: function(response)
            {
                // Remove all skeletons
                removeProductSkeletons();

                // Display the data
                handleServerResponse(response);

                // Reset everything
                _displayNextPageImmediately = false;
                _preloadedServerResponse = null;
                _hasLoadedNextPage = false;
                _isLoadingNextPage = false;
            },
            complete: function()
            {
                $_filterSubmitButton.removeClass('xmx-button--loading');

                // Empty our AJAX handle, since there is nothing
                // to cancel anymore
                _ajaxHandle = null;
            }
        });	
    }

    /**
     * Resets all filters (does not touch sorting)
     */
    function resetFilters()
    {
        _configuration.filters.activeFilterCount = 0;

        if (_configuration.filters.filters)
        {
            for (var filterIndex in _configuration.filters.filters)
            {
                var filter = _configuration.filters.filters[filterIndex];

                _configuration.filters.filters[filterIndex].selected = false;

                switch (filter.type)
                {
                    case 'price':
                    {
                        _configuration.filters.filters[filterIndex].from = null;
                        _configuration.filters.filters[filterIndex].to = null;
                        break;
                    }

                    case 'swatches':
                    case 'multiselect':
                    case 'radio':
                    case 'sizes':
                    case 'thumbnails':
                    case 'rating':
                    {
                        for (var optionIndex in filter.options)
                        {
                            var option = filter.options[optionIndex];

                            if (option.selected)
                            {
                                _configuration.filters.filters[filterIndex].options[optionIndex].selected = false;
                            }
                        }

                        break;
                    }
                }
            }
        }

        // Hide reset button
        $_filterResetButton.hide();

        // Do not auto-expand filters anymore, as we reset everything
        _expandedFilterOptions = [];
    }

    /**
     * Reset sorting (not vanilla Magento like View.php)
     */
    function resetSorting()
    {
        _configuration.sorting.order = _configuration.sorting.defaultOrder;
        _configuration.sorting.direction = 'asc';
    }

    /**
     * 
     */
    function resetEverythingAndReload()
    {
        resetFilters();
        resetSorting();
        commitFilters(null);
    }

    /**
     * 
     */
    function loadNextPage()
    {
        // This method is locked inside the scroll handler, so no need to do it again here

        // Abort AJAX stuff going on right now
        if (_ajaxHandle !== null)
        {
            _ajaxHandle.abort();
        }

        // Build the post data for the next page
        var endpoint = null;
        var postData = null;

        if (_configuration.fillupMode)
        {
            endpoint = '/catalog/category/view/id/' + _configuration.fillupCategory.id;

            // Do not pass in filters to the other category. Just the sorting etc.
            postData = 
            {
                p: _configuration.page + 1,
                dir: _configuration.sorting.direction,
                order: _configuration.sorting.order,
                is_ajax: 1
            };
        }
        else 
        {
            endpoint = '/catalog/category/view/id/' + _configuration.id;
            postData = buildPostData(_configuration.page + 1);
        }

        jQuery.ajax
        ({
            url: endpoint,
            dataType: 'json',
            type: 'post',
            cache: false,
            data: postData,
            xhr: function()
            {
                _ajaxHandle = new window.XMLHttpRequest();

                return _ajaxHandle;
            },
            success: function(response)
            {
                // Remember it for later
                _preloadedServerResponse = response;
                _hasLoadedNextPage = true;

                // Should we display it immediately?
                if (_displayNextPageImmediately)
                {
                    displayPreloadedPage();
                    _displayNextPageImmediately = false;
                }
                else 
                {
                    // Pre-Load images as well. There is no point
                    // to tell the browser about this, if the next
                    // page is displayed immediately
                    preloadProductImages(response);
                }
            },
            complete: function()
            {
                // We are done preloading 
                _isLoadingNextPage = false;

                // Empty our AJAX handle, since there is nothing
                // to cancel anymore
                _ajaxHandle = null;

                // Remove the button loading states
                $_showMoreMessageButton.removeClass('xmx-button--loading');
                $_fillupMessageButton.removeClass('xmx-button--loading');
                $_fillupMessage.hide();
            }
        });	
    }

    /**
     * Fired when the user submits the filter form (e.g. by pressing return) 
     * @param {Event} event 
     */
    function onFilterFormSubmit(event)
    {
        // Track clicks
        /*XmxApp.sendGoogleAnalyticsEvent
        (
            'Category UI',
            'Submitted Filter Form',  
            null,
            false
        );*/

        commitFilters(null);

        event.preventDefault();

        // Cancel event
        return false;
    }

    /**
     *  
     * @param {Event} event 
     */
    function onFilterSubmitButtonClick(event)
    {
        // Track clicks
        /*XmxApp.sendGoogleAnalyticsEvent
        (
            'Category UI',
            'Clicked Filter Submit Button',  
            null,
            false
        );*/

        closeFilterDrawer();

        event.preventDefault();

        // Cancel event
        return false;
    }

    /**
     *  
     * @param {Event} event 
     */
    function onFilterResetButtonClick()
    {
        // Track clicks
        /*XmxApp.sendGoogleAnalyticsEvent
        (
            'Category UI',
            'Clicked Reset All Filters Button',  
            null,
            false
        );*/

        resetEverythingAndReload();
    }

    /**
     * Returns the product object for a given product ID
     * 
     * @param {int} id 
     * @returns object|null
     */
    /*function getProductById(id)
    {
        for (var i in _products)
        {
            if (_products[i].id == id)
            {
                return _products[i];
            }
        }

        return null;
    }*/

    /**
     * Fired when a user has clicked on a product. Used to save the current state before
     * the user goes to the product.
     */
    function onProductLinkClick()
    {
        var $link = jQuery(this);
        var productId = parseInt($link.data('product-id'));
        var position = parseInt($link.data('position'));

        /*global XmxEventQueue*/
        XmxEventQueue.trackEvent('cpc', 
        {
            'p': productId,
            'c': _configuration.id,
            'r': position
        });

        saveState();
    }

    /**
     *  
     */
    function onFilterDrawerSkrimClick()
    {
        closeFilterDrawer();
    }

    /**
     * Opens the filter drawer, if possible
     */
    function openFilterDrawer()
    {
        // Render the filters, if not done already
        if (!_didUpdateFilters)
        {
            updateFilters();
            updateSubmitButtonLabel();
            updateResetFiltersButton();

            _didUpdateFilters = true;
        }

        if (_isDrawerOpened || _isDrawerAnimating)
        {
            return;
        }
        
        _isDrawerAnimating = true;

        $_html.addClass('xmx--prevent-scrolling');
        $_filterDrawer.addClass('xmx-drawer--visible');
        $_filterDrawer.offset(); // Force reflow
        $_filterDrawer.addClass('xmx-drawer--open');

        setTimeout(function() 
        {
            _isDrawerOpened = true;
            _isDrawerAnimating = false;
            
        }, 250);
    }

    /**
     * Closes the filter drawer, if possible
     */
    function closeFilterDrawer()
    {
        if (!_isDrawerOpened || _isDrawerAnimating)
        {
            return;
        }

        _isDrawerAnimating = true;

        $_html.removeClass('xmx--prevent-scrolling');
        $_filterDrawer.removeClass('xmx-drawer--open');

        setTimeout(function() 
        {
            _isDrawerOpened = false;
            _isDrawerAnimating = false;

            $_filterDrawer.removeClass('xmx-drawer--visible');
        }, 200);
    }

    /**
     * Public interface
     */
    return { // line break is not allowed here

        /**
         * Constructor, boots the checkout
         */
        construct: function() 
        {
            boot();
        },

        isFilterDrawedOpen: function()
        {
            return _isDrawerOpened;
        },
    };
})();

XmxCategory.construct();